import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import FieldName from "./FieldName.js";
import DataGridFlexContainer from "../../ui/DataGridFlexContainer.js";
import { SanitizedHTML } from "../../ui/index.js";
import { getStr, measureGridWidth } from "../../util/index.js";
import { makeStyles } from "../../util/tss-react/index.js";
const useStyles = makeStyles()(theme => ({
    margin: {
        marginBottom: theme.spacing(4),
    },
    cell: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
}));
export default function DataGridDetails({ value, prefix, name, }) {
    const { classes } = useStyles();
    const [checked, setChecked] = useState(false);
    const keys = Object.keys(value[0]).sort();
    const unionKeys = new Set(keys);
    const rows = Object.entries(value).map(([k, val]) => {
        const { id, ...rest } = val;
        return {
            id: k,
            identifier: id,
            ...rest,
        };
    });
    for (const val of value) {
        for (const k of Object.keys(val)) {
            unionKeys.add(k);
        }
    }
    let colNames;
    if (unionKeys.has('id')) {
        unionKeys.delete('id');
        colNames = ['identifier', ...unionKeys];
    }
    else {
        colNames = [...unionKeys];
    }
    const widths = colNames.map(e => measureGridWidth(rows.map(r => r[e])));
    if (unionKeys.size < keys.length + 5) {
        return (_jsxs("div", { className: classes.margin, children: [_jsx(FieldName, { prefix: prefix, name: name }), _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: checked, onChange: event => {
                            setChecked(event.target.checked);
                        } }), label: _jsx(Typography, { variant: "body2", children: "Show options" }) }), _jsx(DataGridFlexContainer, { children: _jsx(DataGrid, { disableRowSelectionOnClick: true, rows: rows, rowHeight: 20, columnHeaderHeight: 35, hideFooter: rows.length < 25, showToolbar: checked, columns: colNames.map((val, index) => ({
                            field: val,
                            width: widths[index],
                            renderCell: ({ value }) => (_jsx("div", { className: classes.cell, children: _jsx(SanitizedHTML, { html: getStr(value || '') }) })),
                        })) }) })] }));
    }
    return null;
}
